exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-card--material__avatar{position:relative;top:-64px;margin-bottom:-32px}.v-card--material__heading{position:relative;top:-40px;transition:.3s ease;z-index:1}.v-card--material.v-card--material--hover-reveal:hover .v-card--material__heading{transform:translateY(-40px)}", ""]);

// exports
